import { CommonConfig } from "../shared/common-config";

export class TranslationConfig extends CommonConfig {
    translatedLanguages: string[] = ["en", "hu"];
}